import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http'; // تم التعديل هنا
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
  TranslationObject,
} from '@ngx-translate/core';
import { firstValueFrom, Observable } from 'rxjs';
import { AuthService } from './services/auth.service';
import { authInterceptor } from './services/auth.interceptor'; // تأكد من المسار الصحيح
import { errorInterceptor } from './services/error.interceptor';
import { routes } from './app.routes';
import { AppEnvironment } from 'sham-components/services';
import { appEnvFactory } from '@/app/services/appEnvFactory';

class CustomTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<TranslationObject> {
    return this.http.get<TranslationObject>(`/assets/i18n/${lang}.json`);
  }
}

export function httpLoaderFactory(http: HttpClient) {
  return new CustomTranslateLoader(http);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),

    provideAppInitializer(() => {
      const appEnv = inject(AppEnvironment);
      const authService = inject(AuthService);

      const init = appEnvFactory(appEnv).then(() =>
        Promise.allSettled([
          firstValueFrom(authService.processRefreshVerification()),
        ]),
      );

      return init;
    }),

    // الحل الجوهري: تفعيل الـ Interceptor هنا
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideRouter(routes),

    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
  ],
};
